export const getBankImage = (banks, bankName) => {
  if (banks && banks.length > 0) {
    const indexToFind = banks.findIndex(el => el.nomebanca === bankName);
    if (indexToFind >= 0) {
      return banks[indexToFind].img;
    } else {
      return null;
    }
  }
  return null;
};
